import { PublicKey } from "@solana/web3.js";
import { useEffect, useState } from "react";
import { NodeInfoProps } from "../../interfaces";
import { RaydiumLiquidityPool } from "../../state/flowchart-store";
import { getAllRaydiumPools } from "../../utils/raydium";
import TokenAccountChooser from "../tokens/TokenAccountChooser";
import TokenLine from "../tokens/TokenLine";

const RaydiumSwapNodeInfo = (props: NodeInfoProps & { inputMint?: string }) => {
  const [includedMints, setIncludedMints] = useState<string[] | undefined>(
    undefined
  );
  const getPossibleOutMintsForInMint = async (
    _inpMint?: string | PublicKey
  ) => {
    const lps = await getAllRaydiumPools();
    if (_inpMint) {
      const inpMint = new PublicKey(_inpMint);
      return lps
        .filter(
          (lp) => lp.baseMint.equals(inpMint) || lp.quoteMint.equals(inpMint)
        )
        .map((lp) => {
          if (lp.baseMint.equals(inpMint)) return lp.quoteMint.toBase58();
          else return lp.baseMint.toBase58();
        });
    } else {
      const allMints = lps
        .map((lp) => [lp.baseMint.toBase58(), lp.quoteMint.toBase58()])
        .flat();
      // dedup the mints
      return [...new Set(allMints)];
    }
  };
  // TODO: put set/ unset into its own component
  useEffect(() => {
    getPossibleOutMintsForInMint(props.inputMint).then((mints) =>
      setIncludedMints(mints)
    );
  }, [props.inputMint]);
  return (
    <>
      Out Mint:{" "}
      {props.input.outMint ? (
        <TokenLine mint={props.input.outMint} />
      ) : (
        <>Unset</>
      )}
      {/* {props.input.outMint} */}
      <TokenAccountChooser
        buttonText={"Choose mint"}
        includedMints={includedMints}
        onSelect={(token) => {
          props.updateInput({
            outMint: token.address,
          });
        }}
      />
    </>
  );
};

export default RaydiumSwapNodeInfo;
